import React from 'react';

interface IndicatorInfoButtonProps {
  indicatorKey: string;
  indicatorLabel: string;
  onIndicatorInfoClick: (indicatorKey: string) => void;
  className?: string;
  size?: 'small' | 'medium';
}

/**
 * Reusable component for indicator info buttons.
 * Displays an info icon button that opens an indicator info modal when clicked.
 */
const IndicatorInfoButton: React.FC<IndicatorInfoButtonProps> = ({
  indicatorKey,
  indicatorLabel,
  onIndicatorInfoClick,
  className = '',
  size = 'small'
}) => {
  const sizeClasses = size === 'small' 
    ? 'w-4 h-4' 
    : 'w-5 h-5';
  const iconSizeClasses = size === 'small'
    ? 'w-3.5 h-3.5'
    : 'w-4 h-4';

  return (
    <button
      onClick={() => onIndicatorInfoClick(indicatorKey)}
      className={`inline-flex items-center justify-center ${sizeClasses} ml-1 rounded-full text-gray-600 dark:text-text-secondary hover:text-primary dark:hover:text-highlight-gold hover:bg-primary/10 dark:hover:bg-highlight-gold/10 transition-colors align-middle ${className}`}
      title={`Learn more about ${indicatorLabel}`}
    >
      <svg className={iconSizeClasses} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" strokeWidth="2"/>
        <path d="M12 16v-4" strokeWidth="2" strokeLinecap="round"/>
        <path d="M12 8h.01" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    </button>
  );
};

export default IndicatorInfoButton;

